// Auto-generated from translation.csv; do not edit manually
export const koKR = {
  "accountGuide": {
    "content": "Touka 소속의 아무 게임이나 열고, 게임 내 설정 화면으로 이동하여 이메일을 연동하면 특별 할인 상품 혜택을 누릴 수 있습니다!",
    "title": "계정을 어떻게 생성하나요?"
  },
  "bottomNav": {
    "home": "홈페이지",
    "myOrders": "내 주문"
  },
  "common": {
    "loading": "로딩 중...",
    "noData": "데이터 없음",
    "server": "서버"
  },
  "footer": {
    "language": "중국어(간체)",
    "privacyPolicy": "개인정보 처리방침",
    "termsOfService": "서비스 약관",
    "userSupport": "사용자 지원",
    "downloadNow": "지금 다운로드!"
  },
  "header": {
    "characterName": "캐릭터 이름",
    "gameServer": "게임 서버 그룹",
    "selectGameServer": "게임 지역 선택",
    "greeting": "안녕하세요",
    "loginPrompt": "로그인해 주세요",
    "switchServer": "전환",
    "title": "게임 충전 플랫폼",
    "logout": "로그아웃"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "앗차! 크로코"
  },
  "history": {
    "backToGameZone": "게임 스토어로 돌아가기",
    "allGames": "전체 게임",
    "empty": "아직 주문이 없어요～",
    "filter": {
      "all": "전체",
      "closed": "닫힘",
      "completed": "완료",
      "inProgress": "진행 중",
      "pendingDelivery": "배송 대기"
    },
    "orderTime": "주문 시간:",
    "pendingAutoCancelPrefix": "주문이",
    "pendingAutoCancelSuffix": "후 자동으로 취소됩니다",
    "cancelOrder": "주문 취소",
    "payOrder": "결제",
    "cancelOrderConfirmTitle": "주문을 취소할까요?",
    "cancelOrderConfirmPrimary": "취소 확인",
    "cancelOrderDismiss": "지금은 취소 안 함",
    "status": {
      "cancelled": "취소됨",
      "completed": "거래 완료",
      "paid": "결제 완료",
      "pending": "결제 대기",
      "shipped": "배송됨"
    }
  },
  "home": {
    "selectGame": "충전할 게임 선택",
    "selectGameParts": {
      "prefix": "",
      "keyword": "충전",
      "suffix": "할 게임 선택"
    },
    "noRoleAccount": "이 게임에 아직 캐릭터가 없습니다. 구매 전 게임에서 캐릭터를 먼저 생성해 주세요.",
    "noRoleRefreshPrefix": "이미 계정을 만드셨나요? 눌러서 ",
    "noRoleRefreshAction": "새로고침",
    "noRoleRefreshing": "새로고침 중…",
    "noRoleRefreshNotFound": "캐릭터 정보를 찾을 수 없습니다",
    "noRoleRefreshFailed": "새로고침에 실패했습니다. 잠시 후 다시 시도해 주세요."
  },
  "login": {
    "agreeTerms": {
      "and": "및",
      "prefix": "개인정보 처리방침 및 서비스 약관에 동의합니다",
      "privacy": "개인정보 처리방침",
      "terms": "서비스 약관"
    },
    "cancel": "취소",
    "bindGameGuide": "게임 연동 안내",
    "bindGameGuideContent": "Touka 게임을 실행한 뒤\n게임 내 설정에서\n이메일을 연동하면\n특가 상품을 이용할 수 있습니다!",
    "captchaPlaceholder": "인증 코드",
    "invalidCaptcha": "4자리 인증 코드를 입력하세요",
    "email": "이메일",
    "emailNotBound": "검색에 실패했습니다, 게임 내 연동한 이메일을 입력해 주세요~",
    "emailPlaceholder": "이메일 주소를 입력해 주세요",
    "keepLogin": "15일 동안 로그인 상태 유지",
    "loading": "로그인 중...",
    "loginToStore": "Touka Store 로그인",
    "noAccount": "아직 계정이 없으신가요?",
    "password": "비밀번호",
    "passwordPlaceholder": "비밀번호를 입력해 주세요",
    "submit": "로그인",
    "title": "로그인",
    "invalidEmail": "유효한 이메일 주소를 입력해 주세요"
  },
  "logout": {
    "cancel": "취소",
    "confirm": "확인",
    "dontRemind": "다음부터 알림 안 함",
    "messageLine1": "로그아웃 후, 최근 30일 내 모든 기기의",
    "messageLine2": "로그인 상태가 만료됩니다.",
    "title": "안내 말씀"
  },
  "menu": {
    "contactSupport": "고객 서비스 문의",
    "gameList": "게임 목록",
    "myOrders": "내 주문"
  },
  "paymentSuccess": {
    "account": "계정:",
    "celebrationTitle": "구매 성공",
    "confirm": "확인",
    "getPaymentInfoFailed": "결제 정보 가져오기 실패",
    "loading": "로딩 중...",
    "orderDate": "주문 날짜:",
    "orderId": "주문 번호:",
    "paymentMethod": "결제 방식:",
    "paypal": "PayPal",
    "price": "가격:",
    "purchaseContent": "구매 내용:",
    "quantity": "구매 수량:",
    "serverAndCharacter": "서버/캐릭터:",
    "title": "구매해 주셔서 감사합니다",
    "total": "전체:",
    "unionPay": "UnionPay",
    "amountPaid": "실제 결제 금액:",
    "closeModal": "닫기"
  },
  "productModal": {
    "confirm": "확인",
    "purchaseDetails": "구매 내역",
    "quantity": "수량:",
    "total": "전체:",
    "unitPrice": "단가:"
  },
  "products": {
    "giftPacks": "패키지",
    "diamond": "다이아",
    "products": "상품",
    "vouchers": "바우처",
    "toukaCoin": "Touka 코인",
    "toukaCoinBonusTip": "TOUKA Store에서 구매 시 추가 10% 보상을 받으세요!",
    "superValue": "초특가",
    "limitShort": "제한",
    "remainingShort": "남은 시간",
    "giftPackLimitType": {
      "lifetime": "평생 특가",
      "weekly": "주간 특가",
      "monthly": "월간 특가"
    },
    "howToUseVouchers": "Touka 코인 사용 방법",
    "voucherGuide": {
      "title": "Touka 코인 사용 방법",
      "step1": "1.게임 내 우편함에서 구매한 Touka 코인을 확인하세요.",
      "step2": "2.게임 상점 탭 상단에서 Touka 코인 수량을 확인할 수 있습니다. Touka 코인 수량이 구매하려는 패키지에 필요한 수량에 도달하면, Touka 코인이 우선적으로 사용됩니다.",
      "backToProducts": "상품 목록으로 돌아가기"
    }
  },
  "purchaseConfirm": {
    "card": "신용카드/직불카드",
    "confirm": "확인",
    "dontAskAgain": "30일 내 다시 묻지 않기",
    "gameServer": "게임 서버",
    "paymentMethods": "지원하는 결제 수단",
    "paypal": "PayPal",
    "title": "이 계정으로 구매하시겠습니까",
    "unionPay": "은련 카드"
  },
  "serverSelect": {
    "characterLabel": "캐릭터 이름",
    "characterPlaceholder": "캐릭터를 선택하세요",
    "confirm": "확인",
    "noResults": "결과 없음",
    "serverPlaceholder": "서버 이름",
    "title": "게임 지역 선택",
    "title": "게임 서버 선택"
  },
  "support": {
    "cancel": "취소",
    "copied": "복사 완료",
    "copy": "한 번에 복사",
    "description": "자세한 정보는 공식 메일로 문의하세요",
    "title": "고객 지원"
  },
  "verification": {
    "back": "뒤로 가기",
    "enterCode": "계속하려면 인증 코드를 입력하세요",
    "incorrectCode": "인증 코드가 올바르지 않습니다",
    "invalidCode": "6자리 인증 코드를 입력하세요",
    "noCode": "인증 코드를 못 받으셨나요?",
    "sentTo": "인증 코드가 발송되었습니다",
    "submit": "제출",
    "submitting": "제출 중..."
  }
} as const;
